function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M15.14 15.573l-3.974.42L9.52.428l3.974-.42 1.647 15.566z",
  fill: "#656D78"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.5 12.733a.665.665 0 1 1-1.323.14.665.665 0 0 1 1.323-.14z",
  fill: "#F5F7FA"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M12.604 1.105l-1.987.21.946 8.943 1.987-.21-.946-8.943z",
  fill: "#48CFAD"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M9.518.34H5.521v15.654h3.997V.34z",
  fill: "#656D78"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M8.186 12.996a.666.666 0 1 1-1.332 0 .666.666 0 0 1 1.332 0z",
  fill: "#F5F7FA"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M8.52 1.34H6.52v8.992H8.52V1.339z",
  fill: "#FFCE54"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M4.856.34H.86v15.654h3.997V.34z",
  fill: "#656D78"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M3.524 12.996a.666.666 0 1 1-1.333 0 .666.666 0 0 1 1.333 0z",
  fill: "#F5F7FA"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M3.858 1.34H1.859v8.992h1.999V1.339z",
  fill: "#A0D468"
});

var SvgDocumentation = function SvgDocumentation(props) {
  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

export default __webpack_public_path__ + "static/media/documentation.dcdbd0b6.svg";
export { SvgDocumentation as ReactComponent };